<template>
  <div class="d-flex justify-left">
    <div class="pdf-maker-container clickable" @click="makePdf">
      <slot>
        <div class="d-flex align-center justify-left">
          <img 
            src="@/assets/document-pdf-outline.svg"
            class="pressable"/>
          <span class="download-label ml-2">{{$t('download_info')}}</span>
        </div>
      </slot>
      <img ref="footerImage" src="@/assets/pdfFooter.png" style="display:none"/>
    </div>
  </div>
</template>

<script>
  import html2pdf from 'html2pdf.js'
  import utils from '@/utils/utils'
  // import footerImg from '@/assets/'

  export default {
    name: 'PdfMaker',
    props: [ 'printData', 'filePrefix' ],
    methods: {
      makePdf: function () {
        let date = utils.dateToString(new Date()).split('/').join('').split(':').join('').split('-').join('')
        let opt = {
          margin:       0,
          filename:     this.filePrefix + date + '.pdf'
        }
        let content = this.createContent()
        html2pdf().set(opt).from(content).save()
      },
      createContent: function () {
        let container = document.createElement('div')
        container.setAttribute('class', 'pdf')
        for (let index = 0; index < this.printData.length; index++) {
          const data = this.printData[index]
          let element = null
          if (data.element) {
            element = data.element.cloneNode(true)
            const elementsToHide = element.getElementsByClassName('hideWhenPrinting')
            for (let index = 0; index < elementsToHide.length; index++) {
              const elToHide = elementsToHide[index]
              elToHide.style.display = 'none'
            }
          }
          else if (data.text) {
            element = document.createElement('div')
            if (data.class) element.setAttribute('class', data.class)
            const text = document.createTextNode(data.text)
            element.appendChild(text)
          }
          if (element) container.appendChild(element)
        }
        let footerImg = this.$refs.footerImage.cloneNode(true)
        footerImg.style.display = 'inline'
        footerImg.setAttribute('class', 'footerImage')
        container.appendChild(footerImg)
        return container
      }
    },
  }
</script>